import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isDefinedNotEmpty, Store } from '@softline/core';
import { SOFTLINE_FEATURE_MDE_RETOUREN } from '../retouren.shared';
import { RetourenStore } from '../store/retouren.store';

export const retourenGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const store = inject(Store);

  if (state.url.startsWith('/mde-retouren/eingabe-belegdatum')) {
    return true;
  }

  try {
    await store.dispatch(SOFTLINE_FEATURE_MDE_RETOUREN, RetourenStore.actions.loadKopf);
  } catch {
    /* ignore */
  }

  const kopf = store.get(SOFTLINE_FEATURE_MDE_RETOUREN, RetourenStore.getters.kopf);
  const lieferant = store.get(
    SOFTLINE_FEATURE_MDE_RETOUREN,
    RetourenStore.getters.lieferant
  );

  if (!isDefinedNotEmpty(kopf) && !isDefinedNotEmpty(lieferant)) {
    return router.createUrlTree(['/mde-retouren/eingabe-belegdatum']);
  }
  return true;
};
